import * as React from "react";
import {css} from "@emotion/react";
import {pluralize} from "@web2/string_utils";

import {IAPTheme} from "../../app/ap_client";

interface IProps {
    fields?: number;
    onReset: React.MouseEventHandler;
}

export const SearchCriteria: React.FC<IProps> = (props) => {
    const {fields, onReset} = props;

    if (!fields) {
        return null;
    }

    return (
        <div css={searchCriteriaHolder}>
            <strong>{`Wybrano ${fields} ${pluralize(["kryterium", "kryteria", "kryteriów"])(fields)}`}</strong>

            <a onClick={onReset}>
                wyczyść <span className="hidden-xs hidden-sm">pola</span>
            </a>
        </div>
    );
};

const searchCriteriaHolder = (theme: IAPTheme) => css`
    padding: 1rem 1.5rem;
    background-color: ${theme.colors.link_color};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 1.3rem;
    color: #fff;

    > a {
        color: #fff;
        cursor: pointer;
    }
`;
